import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type {
  AiStatus,
  DashboardStats,
  HealthResponse,
} from "@/types/dashboard";

const REFETCH_MS = 15_000;

export function useDashboardStats() {
  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: () => api<DashboardStats>("/dashboard/stats"),
    refetchInterval: REFETCH_MS,
  });
}

export function useHealthServices() {
  return useQuery({
    queryKey: ["dashboard", "health-services"],
    queryFn: () => api<HealthResponse>("/dashboard/health-services"),
    refetchInterval: REFETCH_MS,
  });
}

export interface PlanUsage {
  plan_slug: string;
  plan_name: string;
  scans_this_month: number;
  max_scans_per_month: number;  // 0 = unlimited
  engagements_total: number;
  max_engagements: number;      // 0 = unlimited
}

/** Refetches on window focus so a plan upgrade takes effect without
 *  a full reload. Short stale time keeps the counter close to live. */
export function usePlanUsage() {
  return useQuery({
    queryKey: ["dashboard", "usage"],
    queryFn: () => api<PlanUsage>("/dashboard/usage"),
    refetchInterval: REFETCH_MS,
    refetchOnWindowFocus: true,
    staleTime: 5_000,
  });
}

export function useAiStatus() {
  return useQuery({
    queryKey: ["ai", "status"],
    queryFn: () => api<AiStatus>("/ai/status"),
    refetchInterval: 30_000,
    // The AI status endpoint may be slow; don't block initial render
    retry: false,
  });
}
